<div class="student-item">

    <div class="student-avt" [style.background-color]="avatarColor">
        {{ firstCharacter }}
    </div>
    <div class="student-info">
        <div class="student-name">
            {{ student?.name }}
        </div>

        <div class="student-class">
            {{ student?.className }}
        </div>

        <div class="student-organization">
            {{ student?.officeNm }}
            <span *ngIf="student?.blockNm">
                / {{ student?.blockNm }}
            </span>
            <span *ngIf="student?.unitNm">
                / {{ student?.unitNm }}
            </span>
        </div>

    </div>
</div>